module.exports = __webpack_public_path__ + "img/hero-3-concealed-guide-bottom.1d1134bd.png";